"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Builder = void 0;
const alchemy_ui_1 = require("@m/alchemy-ui");
const HorizontalStack_1 = __importDefault(require("@mdigital/components/dist/components/HorizontalStack"));
const VerticalStack_1 = __importDefault(require("@mdigital/components/dist/components/VerticalStack"));
const react_1 = __importStar(require("react"));
const react_final_form_arrays_1 = require("react-final-form-arrays");
const react_final_form_1 = require("react-final-form");
const styled_1 = require("./styled");
const styled_components_1 = __importDefault(require("styled-components"));
const store_helper_1 = require("../../../../redux/store/store-helper");
const enums_1 = require("../../../../common/enums");
const DeleteButtonWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
`;
const DeleteTooltip = ({ text, button }) => {
    return (react_1.default.createElement(alchemy_ui_1.Tooltip, { trigger: button, contents: text, placement: "top" }));
};
const Item = (props) => {
    var _a, _b, _c, _d;
    return (react_1.default.createElement(HorizontalStack_1.default, { gap: (0, alchemy_ui_1.units)(2) },
        react_1.default.createElement(styled_1.StyledItemContent, null, props.renderItem(props.parent)),
        react_1.default.createElement(DeleteButtonWrapper, null,
            react_1.default.createElement(DeleteTooltip, { text: (_b = (_a = props.configuration.labels) === null || _a === void 0 ? void 0 : _a.deleteItem) !== null && _b !== void 0 ? _b : 'Delete condition', button: (react_1.default.createElement(alchemy_ui_1.IconButton, { palette: "interactiveConstructive", icon: react_1.default.createElement(alchemy_ui_1.DeleteIcon, { "aria-label": (_d = (_c = props.configuration.labels) === null || _c === void 0 ? void 0 : _c.deleteItem) !== null && _d !== void 0 ? _d : 'Delete condition', size: "16" }), onClick: props.deleteItem })) }))));
};
const Group = (props) => {
    const fieldArray = (0, react_final_form_arrays_1.useFieldArray)(`${props.parent}.conditions`);
    const isFormV1 = !(0, store_helper_1.checkProvision)(enums_1.PROVISIONS.FORM_V2);
    const isMobileProperty = (0, store_helper_1.isMobile)();
    (0, react_1.useEffect)(() => {
        if (fieldArray.fields.length == 0 && !props.configuration.allowEmptyGroup) {
            fieldArray.fields.push(props.createItem());
        }
    }, [fieldArray]);
    return (react_1.default.createElement(react_final_form_arrays_1.FieldArray, { name: `${props.parent}.conditions` }, ({ fields }) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return (react_1.default.createElement(VerticalStack_1.default, { gap: (0, alchemy_ui_1.units)(1.5) },
            react_1.default.createElement(HorizontalStack_1.default, { gap: "medium" },
                react_1.default.createElement(styled_1.StyledItemContent, null,
                    react_1.default.createElement(HorizontalStack_1.default, { gap: "small", alignItems: "center" },
                        react_1.default.createElement(react_final_form_1.Field, { name: `${props.parent}.logicalOperator` }, ({ input }) => (react_1.default.createElement(alchemy_ui_1.Select, { disabled: props.isReadOnly, value: input.value, onChange: (option) => input.onChange(option.value), options: props.configuration.operators }))),
                        react_1.default.createElement("div", null, (_a = props.configuration.labels) === null || _a === void 0 ? void 0 : _a.operationSelectorComment))),
                props.deleteGroup && react_1.default.createElement(DeleteTooltip, { text: (_c = (_b = props.configuration.labels) === null || _b === void 0 ? void 0 : _b.deleteGroup) !== null && _c !== void 0 ? _c : 'Delete group', button: react_1.default.createElement(alchemy_ui_1.IconButton, { disabled: props.isReadOnly, palette: "interactiveConstructive", style: { alignSelf: 'flex-start' }, icon: react_1.default.createElement(alchemy_ui_1.DeleteIcon, { "aria-label": (_e = (_d = props.configuration.labels) === null || _d === void 0 ? void 0 : _d.deleteGroup) !== null && _e !== void 0 ? _e : 'Delete group', size: "16" }), onClick: props.deleteGroup }) })),
            react_1.default.createElement(styled_1.StyledConditionContent, { gap: (0, alchemy_ui_1.units)(1.5) },
                react_1.default.createElement(styled_1.StyledConditionItems, { gap: (0, alchemy_ui_1.units)(1.5) }, fields.map((value, index) => (react_1.default.createElement(react_final_form_1.Field, { name: `${value}.type`, key: index }, ({ input }) => {
                    return input.value === 'group' ? (react_1.default.createElement(styled_1.StyledGroupWrapper, null,
                        react_1.default.createElement(Group, { isReadOnly: props.isReadOnly, level: props.level + 1, parent: value, configuration: props.configuration, renderItem: props.renderItem, createItem: props.createItem, deleteGroup: () => fields.remove(index) }))) : (react_1.default.createElement(Item, { parent: value, renderItem: props.renderItem, deleteItem: () => fields.remove(index), configuration: props.configuration }));
                })))),
                react_1.default.createElement(styled_1.StyledMenuButtonContainer, null,
                    react_1.default.createElement(alchemy_ui_1.MenuButton, { disabled: props.isReadOnly, size: "small", priority: "secondary", actions: [
                            {
                                label: (_g = (_f = props.configuration.labels) === null || _f === void 0 ? void 0 : _f.addItem) !== null && _g !== void 0 ? _g : 'Add condition',
                                onClick: () => fields.push(props.createItem()),
                            },
                            ...props.configuration.levels == null ||
                                props.configuration.levels - 1 > props.level ? [{
                                    label: (_j = (_h = props.configuration.labels) === null || _h === void 0 ? void 0 : _h.addGroup) !== null && _j !== void 0 ? _j : 'Add group',
                                    disabled: isMobileProperty && isFormV1,
                                    onClick: () => fields.push({
                                        type: 'group',
                                        logicalOperator: props.configuration.defaultOperator,
                                        conditions: [],
                                    }),
                                }] : []
                        ] }, (_l = (_k = props.configuration.labels) === null || _k === void 0 ? void 0 : _k.add) !== null && _l !== void 0 ? _l : 'Add')))));
    }));
};
const Builder = (props) => {
    return (react_1.default.createElement(Group, { isReadOnly: props.isReadOnly, parent: "", level: 0, configuration: props.configuration, renderItem: props.renderItem, createItem: props.createItem }));
};
exports.Builder = Builder;
